import { StyleSheet } from 'react-native';
import { DeviceInfo } from 'qunar-react-native';

// const border = DeviceInfo.isIOS
//     ? {}
//     : {
//           borderBottomWidth: 0.5,
//           borderColor: '#eee'
//       };

export default StyleSheet.create({
    statusBar: {
        position: 'absolute',
        top: 0,
        width: '100%',
        flexDirection: 'column',
        justifyContent: 'center',
        alignContent:'center',
        backgroundColor: 'red',
        // ...border
    },
    searchBar:{
        flexDirection: 'row',
        justifyContent:'flex-start',
        alignContent:'center',
        alignItems:'center',
        height:32,
        borderRadius:16,
        marginTop:8,
        backgroundColor:'#FFFFFF'
    },
    searchIcon: {
        marginLeft:14,
        marginRight: 5,
        width: 16,
        height: 16,
        fontSize: 16,
        color: '#999999'
    },
    searchText: {
        fontSize: 14,
        color: '#999999'
    },
    selectBar:{
        height: 50,
        flexDirection: 'row',
        justifyContent: 'space-around',
    },
    statusBarItemWrapper: {
        //flex: 1,
        height: '100%',
        justifyContent: 'center',
        alignItems: 'center',
    },


    normalBg:{
        borderRadius:13,
        justifyContent:'center',
        alignItems:'center',
        height:26
        // paddingLeft: 12,
        // paddingRight: 12
    },
    title:{
        fontSize:12,
        textAlign:'center',
    },
});